import {useState, useEffect} from 'react'

interface DeviceType {
  isMobile: boolean
  isTablet: boolean
  isDesktop: boolean
}

export const useInboxResponsive = (): DeviceType => {
  const [deviceType, setDeviceType] = useState<DeviceType>({
    isMobile: false,
    isTablet: false,
    isDesktop: true,
  })

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth

      if (width < 576) {
        setDeviceType({isMobile: true, isTablet: false, isDesktop: false})
      } else if (width < 1024) {
        setDeviceType({isMobile: false, isTablet: true, isDesktop: false})
      } else {
        setDeviceType({isMobile: false, isTablet: false, isDesktop: true})
      }
    }

    handleResize() // Initial check
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return deviceType
}
